module.exports = __webpack_public_path__ + "static/mobile-illustration-89fee553aa9ceed8ef876db1e19cb65c.png";